/**
 * All event listeners
 *
 * https://developers.facebook.com/docs/meta-pixel/reference
 * */

// Load pixel event
jQuery(document).on("pmw:load-pixels", () => {

	if (
		wpmDataLayer?.pixels?.facebook?.pixel_id
		&& !wpmDataLayer?.pixels?.facebook?.loaded
		&& !wpm.doesUrlContainPatterns(wpmDataLayer?.pixels?.facebook?.exclusion_patterns)
	) {
		if (wpm.consent.canPixelBeFired("marketing", "Facebook")) wpm.loadFacebookPixel();
	}
});

// PageView event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:page-view", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		// Get Facebook data from the unified payload structure
		const facebookData = payload.pixels?.facebook;
		
		if (!facebookData) {
			pmw.console.log("Facebook: No data in payload for page_view event");
			return;
		}

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		// pmw.console.log("Facebook: PageView event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

// AddToCart event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:add-to-cart", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		// Get Facebook data from the unified payload structure
		const facebookData = payload.pixels?.facebook;
		
		if (!facebookData) {
			pmw.console.log("Facebook: No data in payload for add_to_cart event");
			return;
		}

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: AddToCart event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

// InitiateCheckout event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:begin-checkout", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: InitiateCheckout event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

// AddPaymentInfo event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:add-payment-info", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log(`Facebook Pixel: ${facebookData.event_name} event sent`, facebookData);

	} catch (error) {
		console.error(error);
	}
});

// AddToWishlist event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:add-to-wishlist", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: AddToWishlist event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

// ViewContent event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:view-item", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: ViewContent event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});


// view search event
// https://developers.facebook.com/docs/meta-pixel/reference
jQuery(document).on("pmw:s2s:search", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: Search event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

// load always event
jQuery(document).on("pmw:load-always", () => {

	try {
		if (wpm.canNotFireFbq()) return;

		wpm.setFbUserData();
	} catch (error) {
		console.error(error);
	}
});

// view order received page event
// https://developers.facebook.com/docs/meta-pixel/reference
// Note: Server-side transmission is handled via PHP CAPI, this only fires the browser pixel
jQuery(document).on("pmw:s2s:purchase", (event, payload) => {

	try {
		if (wpm.canNotFireFbq()) return;
		
		const facebookData = payload.pixels?.facebook;
		if (!facebookData) return;

		fbq("track", facebookData.event_name, facebookData.custom_data, {
			eventID: facebookData.event_id,
		});
		pmw.console.log("Facebook Pixel: Purchase event sent", facebookData);

	} catch (error) {
		console.error(error);
	}
});

document.addEventListener("pmw:consent:update", ({detail}) => {

	const consent = detail;

	try {
		if (!wpmDataLayer?.pixels?.facebook?.loaded) return;

		const consentUpdate = consent.marketing ? "grant" : "revoke";

		fbq("consent", consentUpdate);
		pmw.console.log(`Facebook Consent Mode updated: ${consentUpdate}`);

	} catch (error) {
		console.error(error);
	}
}, true);
